import styled from 'styled-components';

const Tooltip = ({ children = {}, tip = '' }) => {
  return (
    <Wrapper>
      <>
        {children}
        {tip && tip.length > 0 && <div className="tooltiptext">{tip}</div>}
      </>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .tooltiptext {
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    padding: 4px 12px;
    transform: translateY(-34px);
  }

  :hover .tooltiptext {
    visibility: visible;
  }
`;

export default Tooltip;
